"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
var _constants = require("../constants");
const styleOverrides = {
  root: ({
    theme
  }) => ({
    textTransform: 'none',
    minWidth: 'unset',
    minHeight: 'unset',
    fontSize: theme.typography.body1.fontSize,
    padding: '10px 4px',
    marginRight: 20,
    [_breakpoints.default.up('md')]: {
      minWidth: 'unset',
      marginRight: 60,
      fontSize: '2rem',
      padding: '12px 4px'
    },
    [_breakpoints.default.up('lg')]: {
      fontSize: '2rem'
    },
    '&:last-child': {
      marginRight: 0
    }
  }),
  textColorPrimary: {
    color: _constants.colors.oriGrey.A700,
    [`&.${_material.tabClasses.selected}`]: {
      color: _constants.colors.text.primary
    }
  }
};
const defaultProps = {
  disableRipple: true
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
